import React, {useEffect} from "react";
import {Navigate, useParams} from "react-router-dom";
import api from "../../utils/api";
import {Text} from "react-aria-components";
import LabeledSection from "../../components/LabeledSection/LabeledSection";
import {LuCog, LuHardHat} from "react-icons/lu";
import DefaultButton, {SecondaryButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import {LabeledTextField} from "../../components/Fields/LabeledTextField";
import "./SyntheticUserEdit.css"
import SelectableRoles, {SelectedRoles} from "../../components/SelectableRoles/SelectableRoles";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout";



function SyntheticUserEdit() {
    const [syntheticUser, setSyntheticUser] = React.useState(null)
    const [redirect, setRedirect] = React.useState(null)
    const [name, setName] = React.useState("")
    const [roles, setRoles] = React.useState([])
    const [selectedRoles, setSelectedRoles] = React.useState([])

    function onNameChange(e){
        setName(e.target.value)
    }

    function submit() {
        const selectedRoleIds = selectedRoles.map(role => role.id)
        api.updateSyntheticUser(syntheticUser.id, {
            name: name,
            role_ids: selectedRoleIds,
        }).then((response) => {
            if (response) {
                setRedirect(`/users`)
            }
        })
    }

    const {id} = useParams()
    const syntheticUserId = id

    useEffect(() => {
        api.getSyntheticUser(syntheticUserId).then(newSyntheticUser => {
            setSyntheticUser(newSyntheticUser)
            setName(newSyntheticUser.name)
            setSelectedRoles(newSyntheticUser.roles)
        })
        api.listRoles().then(data => {
            setRoles(data)
        })
    }, []);

    if (syntheticUser === null || syntheticUser === undefined) {
        return <LoadingLayout />
    }

    if (redirect !== null) {
        return <Navigate to={redirect} />
    }

    const content = <>
        <div id="synthetic-user-edit">
            <LabeledSection label="General" icon={<LuCog/>}>
                <LabeledTextField
                    label="Name"
                    value={name}
                    placeholder="User Name"
                    onChange={onNameChange}
                    errorLoc={["body", "name"]}
                    hiddenLabel={undefined}
                    name="Name"
                />
            </LabeledSection>

            <LabeledSection label="Available Roles" icon={<LuHardHat/>}>
                <SelectableRoles
                    roles={roles}
                    selectedRoles={selectedRoles}
                    setSelectedRoles={setSelectedRoles}
                />
            </LabeledSection>

            <div className="save-row">
                <SecondaryButton
                    className="cancel-button"
                    text="Cancel"
                    href="/users" />
                <DefaultButton text="Save" onPress={submit} oneClick />
            </div>
        </div>
    </>



    return <FullWidthLayout
        title={`User: ${syntheticUser.name}`}
        mainContent={content}
    />
}


export default SyntheticUserEdit

